import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthenticationService } from '@app/auth';
import { isUserAllowedForCollections } from '@shared/utils/ti-collections-role-selector';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CollectionUserRoleGuard implements CanActivate {
  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly router: Router,
  ) {}

  canActivate(): Observable<boolean> {
    return this.authenticationService.me().pipe(
      map((user) => {
        const hasCollectionAccess = isUserAllowedForCollections(user);
        if (!hasCollectionAccess) {
          this.router.navigate(['/403']);
          return false;
        }
        return true;
      }),
    );
  }
}
